import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import {
  GridColumn,
  GridTemplateCell,
} from '@shared/modules/grid/abstractions';
import { TaxPolicy } from '../../models/tax-policy';

@Component({
  standalone: false,
  selector: 'gstar-transaction-type-cell',
  templateUrl: './transaction-type-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionTypeCellComponent
  implements GridTemplateCell<TaxPolicy>
{
  header = signal<GridColumn | undefined>(undefined);
  row = signal<TaxPolicy | undefined>(undefined);
}
